import { render, staticRenderFns } from "./ShareInformation.vue?vue&type=template&id=464081c0&scoped=true&"
import script from "./ShareInformation.vue?vue&type=script&lang=js&"
export * from "./ShareInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464081c0",
  null
  
)

export default component.exports